module.exports = __webpack_public_path__ + "static/media/Artboard15.e719f9d8.png";